const MODULE_NAME = 'fulcrum/container/Project/FileSection'

const FETCH_PROJECT_FILES = 'fulcrum/container/Project/FileSection/FETCH_PROJECT_FILES'
const FETCH_PROJECT_FILES_START = 'fulcrum/container/Project/FileSection/FETCH_PROJECT_FILES_START'
const FETCH_PROJECT_FILES_SUCCESS = 'fulcrum/container/Project/FileSection/FETCH_PROJECT_FILES_SUCCESS'
const FETCH_PROJECT_FILES_ERROR = 'fulcrum/container/Project/FileSection/FETCH_PROJECT_FILES_ERROR'

const POST_FILE_REMOVE = 'fulcrum/container/Project/FileSection/POST_FILE_REMOVE'
const POST_FILE_REMOVE_START = 'fulcrum/container/Project/FileSection/POST_FILE_REMOVE_START'
const POST_FILE_REMOVE_SUCCESS = 'fulcrum/container/Project/FileSection/POST_FILE_REMOVE_SUCCESS'
const POST_FILE_REMOVE_ERROR = 'fulcrum/container/Project/FileSection/POST_FILE_REMOVE_ERROR'

const PATCH_FILE_NAME = 'fulcrum/container/Project/FileSection/PATCH_FILE_NAME'
const PATCH_FILE_NAME_START = 'fulcrum/container/Project/FileSection/PATCH_FILE_NAME_START'
const PATCH_FILE_NAME_SUCCESS = 'fulcrum/container/Project/FileSection/PATCH_FILE_NAME_SUCCESS'
const PATCH_FILE_NAME_ERROR = 'fulcrum/container/Project/FileSection/PATCH_FILE_NAME_ERROR'

const PATCH_FILE_DESCRIPTION = 'fulcrum/container/Project/FileSection/PATCH_FILE_DESCRIPTION'
const PATCH_FILE_DESCRIPTION_START = 'fulcrum/container/Project/FileSection/PATCH_FILE_DESCRIPTION_START'
const PATCH_FILE_DESCRIPTION_SUCCESS = 'fulcrum/container/Project/FileSection/PATCH_FILE_DESCRIPTION_SUCCESS'
const PATCH_FILE_DESCRIPTION_ERROR = 'fulcrum/container/Project/FileSection/PATCH_FILE_DESCRIPTION_ERROR'

const PATCH_FILE_INTERNAL = 'fulcrum/container/Project/FileSection/PATCH_FILE_INTERNAL'
const PATCH_FILE_INTERNAL_START = 'fulcrum/container/Project/FileSection/PATCH_FILE_INTERNAL_START'
const PATCH_FILE_INTERNAL_SUCCESS = 'fulcrum/container/Project/FileSection/PATCH_FILE_INTERNAL_SUCCESS'
const PATCH_FILE_INTERNAL_ERROR = 'fulcrum/container/Project/FileSection/PATCH_FILE_INTERNAL_ERROR'

const FETCH_FILE = 'fulcrum/container/Project/FileSection/FETCH_FILE'
const FETCH_FILE_START = 'fulcrum/container/Project/FileSection/FETCH_FILE_START'
const FETCH_FILE_SUCCESS = 'fulcrum/container/Project/FileSection/FETCH_FILE_SUCCESS'
const FETCH_FILE_ERROR = 'fulcrum/container/Project/FileSection/FETCH_FILE_ERROR'

const FETCH_FILE_FOR_PREVIEW = 'fulcrum/container/Project/FileSection/FETCH_FILE_FOR_PREVIEW'
const FETCH_FILE_FOR_PREVIEW_START = 'fulcrum/container/Project/FileSection/FETCH_FILE_FOR_PREVIEW_START'
const FETCH_FILE_FOR_PREVIEW_SUCCESS = 'fulcrum/container/Project/FileSection/FETCH_FILE_FOR_PREVIEW_SUCCESS'
const FETCH_FILE_FOR_PREVIEW_ERROR = 'fulcrum/container/Project/FileSection/FETCH_FILE_FOR_PREVIEW_ERROR'

export {
  MODULE_NAME,
  FETCH_PROJECT_FILES,
  FETCH_PROJECT_FILES_START,
  FETCH_PROJECT_FILES_SUCCESS,
  FETCH_PROJECT_FILES_ERROR,
  POST_FILE_REMOVE,
  POST_FILE_REMOVE_START,
  POST_FILE_REMOVE_SUCCESS,
  POST_FILE_REMOVE_ERROR,
  PATCH_FILE_NAME,
  PATCH_FILE_NAME_START,
  PATCH_FILE_NAME_SUCCESS,
  PATCH_FILE_NAME_ERROR,
  PATCH_FILE_DESCRIPTION,
  PATCH_FILE_DESCRIPTION_START,
  PATCH_FILE_DESCRIPTION_SUCCESS,
  PATCH_FILE_DESCRIPTION_ERROR,
  PATCH_FILE_INTERNAL,
  PATCH_FILE_INTERNAL_START,
  PATCH_FILE_INTERNAL_SUCCESS,
  PATCH_FILE_INTERNAL_ERROR,
  FETCH_FILE,
  FETCH_FILE_START,
  FETCH_FILE_SUCCESS,
  FETCH_FILE_ERROR,
  FETCH_FILE_FOR_PREVIEW,
  FETCH_FILE_FOR_PREVIEW_START,
  FETCH_FILE_FOR_PREVIEW_SUCCESS,
  FETCH_FILE_FOR_PREVIEW_ERROR
}
